import {nextOccasionDate,nextPersonOccasionDate,type PersonOccasion} from './people';
/** 기념일 기준 3일 전을 기기의 날짜로 표시한다. */
export function prepDueDate(monthDay:string,now=new Date()):string{
 const date=nextOccasionDate(monthDay,now);date.setDate(date.getDate()-3);
 return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
}

export function prepDueForOccasion(occasion:PersonOccasion,now=new Date()):string|undefined{const date=nextPersonOccasionDate(occasion,now);if(!date)return undefined;date.setDate(date.getDate()-3);return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`}
